export default __webpack_public_path__ + "61c8a092f74c7ed0d4ab488548eb1917.svg";